import { render } from "./DadosPrestador.vue?vue&type=template&id=2f4d5127"
import script from "./DadosPrestador.vue?vue&type=script&lang=js"
export * from "./DadosPrestador.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__